<template>
  <div>
    <order-info :info="info" type="2" :list="infoList"/>
    <div class="form-container">
      <div class="el-descriptions-title">评价信息</div>
      <evaluative-info v-if="tableData.length" credit-round="1"
                       :supplier-type="$route.query.supplierType"
                       :table-data="applyItemPriceIdSet.length===1?[tableData[0]]:tableData"/>
      <evaluative-info v-if="applyItemPriceIdSet.length===1&&tableData.length>1" credit-round="2"
                       :supplier-type="$route.query.supplierType"
                       :table-data="[tableData[1]]"/>
    </div>
    <el-row class="form-container">
      <div class="el-descriptions-title">产品质量评价申请人信息</div>
      <apply-info :applyInfo="info"></apply-info>
    </el-row>
    <div>
      <eui-btn type="secondary" @click="onCancel">返 回</eui-btn>
    </div>
  </div>
</template>

<script>
import auditHistoryInfo from '../ESapply/component/auditHistoryInfo.vue';
import orderInfo from '../components/orderInfo';
import evaluativeInfo from '../reportReview/components/evaluativeInfo';
import applyInfo from '../ESapply/component/applyInfo.vue';
import Api from '@/modules/projectA/api/ESorganization';
import bus from '@/components/common/bus';
import { reportAuditStatusList } from '../components/componentsData';

export default {
  components: { orderInfo, auditHistoryInfo, evaluativeInfo, applyInfo },
  data() {
    return {
      info: {
        evaluationCode: '',
        evaluateMethodName: '',
        className: '',
        auditStatus: ''
      },
      infoList: [
        { label: '评价办法', key: 'evaluateMethodName' },
        { label: '产品类目', key: 'className' },
        { label: 'EQE编码', key: 'evaluationCode' }
      ],
      tableData: [],
      applyItemPriceId: '',
      applyItemPriceIdSet: []
    };
  },
  created() {
    const { allId } = this.$route.query;
    if (typeof allId === 'string') {
      this.applyItemPriceId = allId;
      this.applyItemPriceIdSet = [allId];
    } else {
      this.applyItemPriceId = allId[0];
      this.applyItemPriceIdSet = allId;
    }
    this.$set(this.info, 'auditStatus', reportAuditStatusList.find(item => item.id?.toString() === this.$route.query.auditStatus)?.name || '');
    this.getData();
  },
  methods: {
    /**
     * 获取基础信息
     */
    getData() {
      Api.getEvaluationApplyGradeDetail({
        applyId: this.$route.query.applyId,
        applyItemPriceIdSet: this.applyItemPriceIdSet
      }).then(res => {
        if (res.code === '200') {
          const info = res.data.evaluationApplyItemPriceVOList[0];
          this.info = {
            ...info,
            ...res.data
          };
        }
      });
      // 评价信息
      if (this.applyItemPriceIdSet.length === 1) {
        Api.queryReportAuditEvaluationInfo({
          supplierType: this.$route.query.supplierType,
          evaluationItemId: this.$route.query.evaluationItemId,
          id: this.$route.query.id
        }).then(res => {
          if (res.code === '200') {
            if (res.data.length) {
              let list = [];
              // 如果是复评，但是只有一条数据
              if (this.$route.query.creditRound !== '1' && res.data.length === 1) {
                list.push({
                  ...res.data[0],
                  productTest: '',
                  compositeScore: '',
                  grade: '',
                  testReportAttachPath: ''
                });
              }
              list = list.concat(res.data);
              this.tableData = list;
            }
          }
        });
      } else {
        // 合并评价信息
        Api.queryCoverEvaluationInfo({
          supplierType: this.$route.query.supplierType,
          itemPriceIdList: this.applyItemPriceIdSet
        }).then(res => {
          if (res.code === '200') {
            this.tableData = res.data;
          }
        });
      }
    },
    /**
     * 取消
     */
    onCancel() {
      bus.$emit('close_current_tags');
    },
    /**
     * 提交
     */
    onSubmit() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交？', '易派客提醒您', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(async () => {
            Api.leaderAudit({
              applyId: this.$route.query.applyId,
              evaluationApplyItemPriceId: this.$route.query.id,
              evaluationItemId: this.$route.query.evaluationItemId,
              ...this.form,
              retResult: this.form.result === '2' ? this.form.retResult : undefined
            }).then(res => {
              if (res.code === '200') {
                this.$message.success('操作成功');
                setTimeout(() => {
                  this.onCancel();
                }, 2000);
              }
            });
          });
        }
      });
    }
  }
};
</script>


<style lang="scss" scoped>
  @import "../components/common";
</style>